import * as Twilio from '@twilio/voice-sdk';

import { DossierId } from '../dossier/types';
import { datadogLogger } from '../../shared/datadog/logger';

/**
 * Type guard to check if an error is a Twilio error
 * @param error - the error to check
 * @returns true if the error is a Twilio error
 */
export function isTwilioError(error: unknown): error is Twilio.TwilioError.TwilioError {
    return (
        error !== null &&
        typeof error === 'object' &&
        'code' in error &&
        typeof (error as { code: unknown }).code === 'number'
    );
}

/**
 * Helper to log phone call errors consistently to Datadog with [Phoning] prefix
 * @param message - the error message
 * @param error - the error
 * @param context - contextual information (dossierId, phoneCallId)
 */
export function logPhoneCallError(
    message: string,
    error: unknown,
    context: {
        dossierId: DossierId | null;
        phoneCallId?: number | null;
    },
): void {
    datadogLogger.error(`[Phoning]: ${message}`, {
        dossierId: context.dossierId,
        ...(context.phoneCallId && { phoneCallId: context.phoneCallId }),
        errorCode: isTwilioError(error) ? error.code : undefined,
        errorMessage: error instanceof Error ? error.message : String(error),
    });
}
